











import Vue from "vue";
import { Util } from "@/util/util";
import PillWithLabel from '@/components/v2/PillWithLabel.vue';

export default Vue.extend({
  name: "PdfDownloadLinkV2",
    components: {PillWithLabel},
  data() {
    return <{
      loading: boolean,
    }>{
      loading: false
    };
  },
  props: {
    fileName: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: false
    }
  },
  computed: {
    currentPage(): string {
      return window.location.href;
    },

    pageUrl(): string {
      const pageUrl = (this.url) ? this.url : this.currentPage;
      return encodeURIComponent(pageUrl);
    },

    name(): string {
      return encodeURIComponent(this.fileName + '.pdf');
    },

    link(): string {
      return `${Util.getConfig().restBasePath.pdf}/pdf?pageUrl=${this.pageUrl}&name=${this.name}`;
    },

  }

});
